import { render, staticRenderFns } from "./Marketwheel.vue?vue&type=template&id=4ecc655f&scoped=true&"
import script from "./Marketwheel.vue?vue&type=script&lang=js&"
export * from "./Marketwheel.vue?vue&type=script&lang=js&"
import style0 from "./Marketwheel.vue?vue&type=style&index=0&id=4ecc655f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ecc655f",
  null
  
)

export default component.exports